export class ControlledError extends Error {
  constructor(message: string) {
    super(message);

    Error.captureStackTrace(this, ControlledError.captureStackTrace);
  }
}
